import { render, staticRenderFns } from "./document-meta.vue?vue&type=template&id=c835318e&scoped=true&"
import script from "./document-meta.vue?vue&type=script&lang=js&"
export * from "./document-meta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c835318e",
  null
  
)

export default component.exports